export async function loadPage(pagesMap, pageKey) {
    const currentPageImport = pagesMap[pageKey];

    currentPageImport && (await currentPageImport());
}
